import { render } from "./CollectionDetail.vue?vue&type=template&id=71c66999&scoped=true&ts=true"
import script from "./CollectionDetail.vue?vue&type=script&lang=ts"
export * from "./CollectionDetail.vue?vue&type=script&lang=ts"

import "./CollectionDetail.vue?vue&type=style&index=0&id=71c66999&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src186255619/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c66999"]])

export default __exports__